'use client';
import React, { useState, useEffect } from 'react';

const PHONE = '9492935721';
const SMS_LINK = `sms:${PHONE}`;
const CALL_LINK = `tel:+1${PHONE}`;

export default function StickyCTA() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setVisible(window.scrollY > 300);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div
      className="fixed bottom-0 inset-x-0 z-40 md:hidden transition-transform duration-300"
      style={{
        transform: visible ? 'translateY(0)' : 'translateY(100%)',
        background: 'rgba(10,10,10,0.97)',
        borderTop: '1px solid rgba(107,33,168,0.35)',
        backdropFilter: 'blur(16px)',
        WebkitBackdropFilter: 'blur(16px)',
        paddingBottom: 'env(safe-area-inset-bottom, 0px)',
      }}
    >
      <div className="flex items-stretch gap-0" style={{ height: '60px' }}>
        {/* Text for Quote — primary */}
        <a
          href={SMS_LINK}
          className="flex-1 flex items-center justify-center gap-2"
          style={{
            background: 'var(--mamba-purple-bright)',
            color: 'white',
            fontFamily: 'Manrope, sans-serif',
            fontWeight: 700,
            fontSize: '13px',
            letterSpacing: '0.06em',
            textTransform: 'uppercase',
            textDecoration: 'none',
          }}
        >
          <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
            <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/>
          </svg>
          Text for a Quote
        </a>
        {/* Divider */}
        <div style={{ width: '1px', background: 'rgba(107,33,168,0.4)', flexShrink: 0 }} />
        {/* Call Now — secondary */}
        <a
          href={CALL_LINK}
          className="flex items-center justify-center gap-2"
          style={{
            width: '120px',
            background: 'rgba(212,175,55,0.08)',
            color: 'var(--mamba-gold-light)',
            fontFamily: 'Manrope, sans-serif',
            fontWeight: 700,
            fontSize: '13px',
            letterSpacing: '0.06em',
            textTransform: 'uppercase',
            textDecoration: 'none',
            flexShrink: 0,
          }}
        >
          <svg width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
            <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.81 19.79 19.79 0 01.01 1.18 2 2 0 012 0h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 14.92z"/>
          </svg>
          Call Now
        </a>
      </div>
    </div>
  );
}
